import React from 'react';
import { graphql } from 'react-apollo';
import Spinner from '../../spinner/spinner';
import { Button, Form } from 'antd';
import CreateEvangelistForm from './createEvangelistForm';
import { createEvangelist } from './mutations/createEvangelist';

class CreateEvangelistPage extends React.Component {
  mutationParams = () => {
    return {
      variables: {
        input: {
          ...this.props.form.getFieldsValue()
        }
      }
    }
  };

  redirectTo = (data) => {
    this.props.history.push(`/dashboard/admin/evangelists`);
  };

  formControls(loading) {
    return (
      <Button type="primary" htmlType="submit" className="login-form__login-button" loading={loading}>
        Invite Evangelist
      </Button>
    );
  }

  render() {
    if (this.props.data && this.props.data.loading) {
      return (
        <Spinner/>
      );
    } else {
      return (
        <CreateEvangelistForm {...this.props } formControls={this.formControls}
                             mutationParams={this.mutationParams}
                             redirectTo={this.redirectTo}/>
      );
    }
  }
}

export default Form.create()(graphql(createEvangelist)(CreateEvangelistPage));



// WEBPACK FOOTER //
// ./src/components/pages/evangelists/evangelistCreate.js